<template>
  <zm-button size='large' round type='primary' @click='goToHDPage'> {{ $t('billing.success.get_started') }}</zm-button>
</template>
<script>
export default {
  methods: {
    goToHDPage() {
      this.$tracking.buyInteraction('purchase confirmation', 'explore my plan');
      window.location.href = '/myhome';
    },
  },
}
</script>
